<template>
    <div class="modal" v-show="isOpen" :key="openCounter" v-on:click="close()">
        <div class="modal-content" :class="{ 'modal-content-small' : small }" v-on:click="$event.stopPropagation()">
            <span v-on:click="close()" class="material-icons close">close</span>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: "Modal",
        props: {
            openCounter: Number,
            title: String,
            small: Boolean,
            closeButton: Boolean
        },
        data: function () {
            return {
                modal: Object,
                span: Object,
                isOpen: false
            }
        },
        methods: {
            close: function () {
                Vue.set(this, 'isOpen', false);
                this.$emit("user-closed");
            },
            open: function () {
                Vue.set(this, 'isOpen', true);
            }
        },
        mounted() {
            if(this.small == null)
                this.small=false;
            if(this.closeButton == null)
                this.closeButton=true;
        },
        watch: {
            openCounter: function (newVal, oldVal) { // watch it
                if (newVal > oldVal)
                    this.open();
                else
                    this.close();
            }
        }
    }
</script>

<style scoped>
    .modal {
        position: fixed; /* Stay in place */
        z-index: 3; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    .modal-content {
        background-color: #fefefe;
        margin: 5% auto auto auto;
        padding: 20px;
        border: 0;
        width: 70%;
        border-radius: 0.75em;
        z-index: 4;
        display: table;
    }


    .modal-content-small {
        background-color: #fefefe;
        margin: 15% auto auto auto;
        padding: 20px;
        border: 0;
        width: 30%;
        border-radius: 0.75em;
        z-index: 4;
        height: auto;
        display: table;
    }

    .material-icons {
        font-size: 32px;
    }

    .close {
        color: #666666;
        float: right;
        cursor: pointer;
    }

    .done-button {
        color: white;
        float: right;
    }

    .done-button-small {
        width: 100%;
    }

    .modal-open {
        display: block;
    }

    .modal-close {
        display: none;
    }
</style>